import React, { useContext, useState, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import { Text, Button, Logo, RowContainer } from "../style";
import { sendCommand } from "../../../util/util";
import seer from "../../../static/seer.svg";
import withTurn from "..";
import ChatArea from "../../ChatArea";

const Seer = () => {
  const { username, members, websocket } = useContext(AppContext);
  const [done, setDone] = useState(false);

  useEffect(() => {
    setDone(false);
    return () => {
      setDone(false);
    };
  }, [setDone]);

  return (
    <>
      <RowContainer>
        <Logo src={seer} alt="logo" />
        <Text>You're a Seer</Text>
        {done ? 
        <Text>Only one person per night</Text>
        : 
          <>
          <Text>Select who you want to see tonight</Text>
          {members
            .filter((member) => member !== username)
            .map((member) => (
              <Button
                key={member}
                onClick={() => {
                  sendCommand(websocket, "see_role", member);
                  setDone(true);
                }}
              >
                {member}
              </Button>
            ))}
            </>
          }
      </RowContainer>
      <ChatArea />
    </>
  );
};

export default withTurn(Seer);
